import React, { useEffect, useState, useCallback,useRef } from "react";
import {
  Box,
  Heading,
  VStack,
  FormControl,
  Input,
  Button,
  Center,
  Image,
  NativeBaseProvider,
  Select,
  CheckIcon,
  Modal,
  Divider,
  Text,
  ScrollView,
  useToast,
  Alert,
  HStack,
  Icon,
  Pressable,
} from "native-base";
import { GlobalStyles } from "../constants/styles";
import { GlobalConstants } from "../constants/constants";
import { useWindowDimensions,ImageBackground,StyleSheet } from "react-native";


const AvailableCities = () => {
     const { width } = useWindowDimensions();
     const isMobile = width < 768;
     const [modalVisible, setModalVisible] = useState(false);
     const initialRef = useRef(null);
     const finalRef = useRef(null);

const AvailableCities = [

   {
    title: "Available Cities",
    image: require("../../assets/Home/cities.png"),
    text: `
TownTicks is currently available in these cities.

Toronto

Dubai
    `,
  },
]

const SectionTitle = ({ children, icon, w = "100%" }) => {
  return (
    <HStack
      alignItems="center"
      space={{ base: 2, md: 3 }}
      mb={{ base: 5, md: 7 }}
      w={w}
    >
      <Image
        source={icon}
        alt="section-icon"
        resizeMode="contain"
        w={{
          base: "20px",
          sm: "25px",
          md: "32px",
          lg: "40px",
        }}
        h={{
          base: "20px",
          sm: "25px",
          md: "32px",
          lg: "40px",
        }}
      />

      <Text
        color="#22004B"
        fontFamily="Inknut Antiqua"
        fontWeight="400"
        fontSize={{
          base: "18px",
          sm: "24px",
          md: "32px",
          lg: "45px",
        }}
        lineHeight={{
          base: "32px",
          sm: "45px",
          md: "65px",
          lg: "97px",
        }}
        letterSpacing={{
          base: "-0.6px",
          sm: "-0.8px",
          md: "-1.2px",
          lg: "-1.6px",
        }}
        flex={1}
      >
        {children}
      </Text>
    </HStack>
  );
};
const AvailableCitiesSection = ({ isMobile }) => {
  return (
    <Box
      w="100%"
      minW="100%"
      py={{ base: 6, md: 8 }}
      alignSelf="center"
    >
      <SectionTitle icon={require("../../assets/Home/star.png")}>
        Available Cities
      </SectionTitle>

      <VStack
        w="100%"
        minW="100%"
        alignSelf="center"
      >
        {AvailableCities.map((item, index) => (
          <Box
            key={index}
            w="100%"
            minW="100%"
            py={{ base: 5, md: 7 }}
            alignSelf="stretch"
          >
            <HStack
              w="100%"
              minW="100%"
              alignItems="center"
              justifyContent="space-between"
              flexDirection={isMobile ? "column" : "row"}
              space={{ base: 4, md: 8 }}
            >
              {/* IMAGE */}
              <Box
                w={{ base: "100%", md: "45%" }}
                alignItems="center"
              >
                <Image
                  source={item.image}
                  alt={item.title}
                  resizeMode="contain"
                  w={{
                    base: "180px",
                    sm: "220px",
                    md: "280px",
                    lg: "333px",
                  }}
                  h={{
                    base: "170px",
                    sm: "205px",
                    md: "260px",
                    lg: "313px",
                  }}
                />
              </Box>

              {/* TEXT */}
              <Box
                w={{ base: "100%", md: "50%" }}
              >
                <Text
                  color="#000000"
                  fontFamily="Inter"
                  fontWeight="500"
                  fontSize={{
                    base: "14px",
                    sm: "16px",
                    md: "20px",
                    lg: "24px",
                  }}
                  lineHeight={{
                    base: "21px",
                    sm: "24px",
                    md: "28px",
                    lg: "32px",
                  }}
                  letterSpacing="0%"
                  textAlign={isMobile ? "center" : "justify"}
                >
                  {item.text.trim()}
                </Text>
              </Box>
            </HStack>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

  return (
    <>
      <ScrollView>
        <Box alignItems="center" bg="white">
             <ImageBackground
                        source={require("../../assets/Home/hero.png")}
                        resizeMode="stretch"
                        style={{
                          width: "100%",
                          height:"3vh"
                        }}
                      ></ImageBackground>
             <ImageBackground
                        source={require("../../assets/Home/background.png")}
                        resizeMode="stretch"
                        style={{
                          width: "100%",
                          height: "90vh"
                        //   marginTop:"30px"
                        }}
                      >
                        <Center ml={10}>
                            <AvailableCitiesSection isMobile={isMobile} />
                        </Center>
                      </ImageBackground>
          
        </Box>  
        <Box mt={10}>
            <HStack
                bg="#373737"
                px={6}
                py={4}
                justifyContent="space-between"
                alignItems="center"
              
            >
                <Text color="#fff" fontSize="12px" fontFamily={GlobalStyles.text.fontFamily}>
                TownTicks is a product of Novelma Inc.
                </Text>

                <Pressable onPress={() => setModalVisible(!modalVisible)}>
                <Text color="#fff" fontSize="12px" fontFamily={GlobalStyles.text.fontFamily}>
                    Contact Us
                </Text>
                </Pressable>
            </HStack>
            </Box>        
      </ScrollView>
      <Modal
              isOpen={modalVisible}
              onClose={() => setModalVisible(false)}
              initialFocusRef={initialRef}
              finalFocusRef={finalRef}
            >
              <Modal.Content>
                <Modal.CloseButton />
                <Modal.Header>Contact Us</Modal.Header>
                <Modal.Body>
                  <Text>
                    To contact or any feedback about TownTicks, write to
                    <Text color={GlobalStyles.colors.blue}>
                      {" "}
                      support.townticks@novelma.com
                    </Text>
                  </Text>
                </Modal.Body>
                <Modal.Footer>
                  <Button.Group space={2}>
                    <Button
                      variant="ghost"
                      colorScheme="blueGray"
                      onPress={() => {
                        setModalVisible(false);
                      }}
                    >
                      Close
                    </Button>
                  </Button.Group>
                </Modal.Footer>
              </Modal.Content>
            </Modal>
    </>
  );
};

export default AvailableCities;
